import React, { useEffect } from "react";

import { useDebugStore } from "~/store/debugStore";

/**
 * Higher-order component (HOC) that adds render tallying to a component
 * @param Component The component to wrap
 * @param componentName The name to use in the render tally (defaults to Component.displayName)
 * @returns The component wrapped with render tallying
 */
export const withRenderTally = <P extends object>(
  Component: React.ComponentType<P>,
  componentName?: string
): React.FC<P> => {
  const displayName = componentName || Component.displayName || Component.name || "UnknownComponent";

  const WithRenderTally: React.FC<P> = (props) => {
    const tallyRender = useDebugStore((state) => state.tallyRender);

    // Track render count using the debug store
    useEffect(() => {
      tallyRender(displayName);
    }, [tallyRender]);

    return <Component {...props} />;
  };

  // Set proper display name for debugging
  WithRenderTally.displayName = `WithRenderTally(${displayName})`;

  return WithRenderTally;
};
